exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn-block.btn-default.buy-btn-cart.download-inv span {\n    display: none;\n}\n\nbutton.btn-block.btn-default.buy-btn-cart.download-inv {\n    background: #ed3136;\n    border: 0px;\n    color: #fff;\n    border-radius: 4px;\n    opacity: 1 !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/package-inv-download/package-inv-download.component.css
// module id = ../../../../../src/app/home/package-inv-download/package-inv-download.component.css
// module chunks = common